module.exports = "/_next/static/images/831fea8f7fb94e155fcbae471b36946e-hero-md.jpg";